import { v4 as uuidv4 } from 'uuid'
import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import { IconColours } from './Colours';
import { WaypointsEntity } from './WaypointEntity';
import { WaypointIcon } from './WaypointIcon';
import { WaypointIconSet } from './WaypointIconSet';
import WaypointProperties from './WaypointProperties';
import { createOrUpdateFromCoordinate } from 'ol/extent';

export const WPT_UNTITLED = 'Untitled'

export default class WaypointFeature extends Feature<Point> {
    waypoint: WaypointsEntity
    order: number
    props: WaypointProperties
    value: string

    constructor(geometryOrProperties: Point|{[key: string]: any}, waypoint: WaypointsEntity, index: number, props?: WaypointProperties, value?: string) {
        super(geometryOrProperties)
        this.waypoint = waypoint
        this.order = index
        this.props = props || new WaypointProperties(WPT_UNTITLED + (WaypointsEntity.nextId++).toString(), WaypointIcon.DEFAULT_ICON, WaypointIcon.DEFAULT_COLOUR, null, null)
        this.setAttrs(this.props.name, this.props.icon, this.props.colour, this.props.proximityAlarm, this.props.comment)
        this.value = value || uuidv4()
        this.setId(this.value)
    }

    public setIcon(icon: string) {
        this.props.icon = icon
        this.setStyle(WaypointIcon.iconFor(this))
    }

    getGeometry(): Point {
        return super.getGeometry()!
    }

    getExtent() {
        return createOrUpdateFromCoordinate(this.getGeometry().getCoordinates());
    }

    public setColour(colour: string) {
        this.props.colour = colour
        this.setStyle(WaypointIcon.iconFor(this))
    }

    public setAttrs (name: string|null, icon: string|null, colour: string|null, proximityAlarm: number|null, comment: string|null) {
        if(name) {
            this.props.name = name // can be null here, if we import from a file with unnamed waypoints
        }
        // We need the waypoint to store the default icon & colour, if they are otherwise blank 
        // or unrecognised, so that they are shown in the initial state of the waypoint editor UI
        this.props.icon = (!icon || !WaypointIconSet[icon]) ? WaypointIcon.DEFAULT_ICON : icon
        this.props.colour = (!colour || !IconColours[colour]) ? WaypointIcon.DEFAULT_COLOUR : colour
        this.props.proximityAlarm = proximityAlarm
        this.props.comment = comment;
    }

    // Return blank values for icon and colour if they are both defaulted, ie have not been 
    // set explicit values, so that we don't add <sym> elements in the GPX if we dont need them.
    public iconOrBlank()   { return (this.props.icon === WaypointIcon.DEFAULT_ICON && this.props.colour === WaypointIcon.DEFAULT_COLOUR) ? "" : (this.props.icon || "") }
    public colourOrBlank() { return (this.props.icon === WaypointIcon.DEFAULT_ICON && this.props.colour === WaypointIcon.DEFAULT_COLOUR) ? "" : (this.props.colour || "") }
}